export default __webpack_public_path__ + "static/media/wishlisted.6716f2d3.svg";